export default class NYNJPATHPositionalSystem {
    static feet_per_marker = 100;
    static display_formats = {
        track_marker_feet: "NYNJPATH",
    };

    static display_fields = {
        TRACK: {
            name: "Track",
            rules: [{ required: true }],
        },
        SECTION: {
            name: "Power Section",
            rules: [{}],
        },
        MARKER: {
            name: "Marker",
            rules: [{ required: true, type: "integer" }],
        },
        FEET: {
            name: "Feet",
            rules: [{ required: true, type: "integer", min: 0, max: 99 }],
        },
    };

    fields(display_format) {
        return NYNJPATHPositionalSystem.fields(display_format);
    }

    static fields(display_format) {
        return ["TRACK", "SECTION", "MARKER", "FEET"];
    }

    displayFields(display_format) {
        if (this.field_value("SECTION")) {
            return NYNJPATHPositionalSystem.displayFieldsWithSection(display_format);
        }
        return NYNJPATHPositionalSystem.displayFields(display_format);
    }

    static displayFieldsWithSection(display_format) {
        return ["SECTION", "MARKER", "FEET"];
    }

    static displayFields(display_format) {
        return ["TRACK", "MARKER", "FEET"];
    }

    field_value(field) {
        switch (field) {
            case "TRACK":
                return this.line;
            case "SECTION":
                return this.subposition;
            case "MARKER":
                return this.marker;
            case "FEET":
                return this.feet;
            default:
                return null;
        }
    }

    static from_fields(system_id, display_format, fields, offsets) {
        const position = fields.MARKER + fields.FEET / NYNJPATHPositionalSystem.feet_per_marker;
        return new NYNJPATHPositionalSystem(system_id, fields.TRACK, position, fields.SECTION);
    }

    static from_search(system_id, fields) {
        const position = parseInt(fields.paramTwo) + parseInt(fields.paramThree) / NYNJPATHPositionalSystem.feet_per_marker;
        return new NYNJPATHPositionalSystem(system_id, fields.paramOne, position, null);
    }

    constructor(system_id, route, position, subposition, sources) {
        this.system = system_id;
        this.route = this.line = route;
        this.position = position;
        this.subposition = subposition;
        this.sources = sources;
        this.sign = position >= 0 ? 1 : -1;
        if (this.sign < 0) {
            position = Math.abs(position);
        }
        this.marker = Math.floor(position);
        this.feet = Math.floor((position - this.marker) * NYNJPATHPositionalSystem.feet_per_marker);
    }

    generalise() {
        return new NYNJPATHPositionalSystem(this.system, this.route, this.position, null);
    }

    to_marker_and_feet_string() {
        const prefix = this.sign < 0 ? "-" : "";
        const feet = Math.floor(this.feet).toString().padStart(2, "0");
        return `Marker: ${prefix}${this.marker} Feet: ${feet}`;
    }

    to_string(display_format, datum_offsets, isHorizontal = false) {
        let trackLabel = "Track: ";
        if (isHorizontal) {
            trackLabel = "";
        }
        let position;
        position = this.to_marker_and_feet_string();
        return `${trackLabel}${this.route} ${position}`;
    }

    to_simple_string(display_format, remove_label) {
        let position;
        position = this.to_marker_and_feet_string();

        if (remove_label) {
            return `${position}`;
        } else {
            return `${this.route} ${position}`;
        }
    }
}
